/*
Global CSS Variables. Note does not hot reload via CSS.

Useable in JS or in CSS

* CSS usage:

  backgound: $varName

* JS usage:

  import variables from '../'

  const { blue } = variables
*/

module.exports = {
  // Colors
  primary: '#24A5C0',
  brandRed: '#fe5850',
  inputBackgroundColorDark: '#404040',
  // Nav size
  navHeight: '55px',
  // Icon sizes
  iconDefault: '35px',
  // -- Indexes
  zIndexHighest: 300,
  zIndexHigher: 200,
  zIndexHigh: 100,
  zIndexNormal: 1,
  zIndexLow: -100,
  zIndexLower: -200,
  // -- Breakpoints
  breakpointXxs: '480px',
  breakpointXs: '600px',
  breakpointSmTablet: '720px',
  breakpointSm: '840px',
  breakpointMd: '960px',
  breakpointLgTablet: '1024px',
  breakpointLg: '1280px',
  breakpointXl: '1440px',
  breakpointXxl: '1600px',
  breakpointXxxl: '1920px',
}



// WEBPACK FOOTER //
// ../src/_variables.js